<template>
	<div id="enterback">
		<div class="enter_head">
			<div class="enter_right">
				<div class="enter_headline" >
					<h2>登录DataGalaxy帐号</h2>
				</div>
				<div style="height: 1px; background-color: #EFF3F6;"></div>
				<div class="enter_wrap_main">
					<div class="phonenum">
						<input type="text" autocomplete="off" @change="refreshpwd" placeholder="手机号" @blur="phoneVerification" v-model="phone"/>
						<span id="login_phonem1" style="float: left;text-align: left;"></span>
					</div>
					<div class="enterpass">
						<input type="password" autocomplete="off" @blur="passwordVerification" placeholder="密码" v-model="password"/>
						<span  id="login_pwdm1" style="float: left;text-align: left;"></span>
					</div>
					<div class="userdefault_enter">
						<span style="float: left;">
							<span id="enter_checkbox">
								<input  v-if="rememberShow" type="checkbox" v-model="remember_username" style="
    vertical-align: text-top;"/>
							</span>
						
						记住帐号
						</span>
					<span id="enter_forget" @click="retrievepassword">忘记密码</span>
					</div>
					<div class="enter_btn" @click="logIn" >
							登录
					</div>
				</div>
			</div>
		</div>
		
		<retrievepassword ref='retrievepassword'></retrievepassword>
	</div>

</template>

<script>
	
	import retrievepassword from '@/messageBox/retrievepassword.vue'
	import Bus from '@/bus.js'
	export default {
		data() {
			return {
				agreement_rdt:``,//用户协议富文本
				forgetpwd_phone:'',
				phone_flag1:false,
				password_verification_flag1:false,
				phone:'',		//手机号
				password:'',	//密码
				remember_username:false,	//是否记住登录
				rememberShow:false
			}
		},
		components:{
			retrievepassword
		},
		mounted(){
			let that = this;
			if(localStorage.getItem('phone') != null && localStorage.getItem('password') != null ){
				this.phone = localStorage.getItem('phone');
				this.password = localStorage.getItem('password');
				this.remember_username = true;
			}
			this.rememberShow = true;
			if(this.$route.query.re_phone){
				this.phone=this.$route.query.re_phone;
				this.password='';
			}		
		},
		methods:{
			//清除密码
			refreshpwd(){
				this.password=''
			},
			//手机号格式验证
			phoneVerification() {
				let that = this;
				let message = document.getElementById('login_phonem1')
				let reg = /^1[3-9]{1}[0-9]{9}$/;
				if(that.phone) {
					if(reg.test(that.phone)) {
						message.innerText = '';
						that.phone_flag1=true;
						return true;
					} else {
						message.innerText = '请输入正确的手机号'
						that.phone_flag1=false;
						return false;
					}
				} else {
					message.innerText = '手机号不能为空'
					that.phone_flag1=false;
					return false;
				}
			},
			//密码格式验证
			passwordVerification() {
				let that = this;
				let message = document.getElementById('login_pwdm1')
				let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/;
				if(that.password) {
					if(reg.test(that.password)) {
						that.password_verification_flag1 = 1;
						message.innerText = ''
						return true 
					} else {
						message.innerText = '密码格式错误'
						that.password_verification_flag1 = false;
						return false 
					}
				} else {
					message.innerText = '密码不能为空'
					that.password_verification_flag1 = false;
					return false 
				}
			},
			//忘记密码
			retrievepassword() {
//				this.flag = false;
				this.$refs.retrievepassword.openretrievesteponepop()
			},
//			let that = this;
			//登录
			logIn(){
				let _this=this;
				this.passwordVerification();
				this.phoneVerification();
				//验证手机号和密码格式...
				if(this.password_verification_flag1&&this.phone_flag1){
					
				//执行登录
				this.$http.get(
					_this.apiUrl+'index.php?m=Api&c=login&a=login',
					{
						params: {  
							"phone":this.phone,
							"password":this.password
						}  
					}
				).then(response => {
					//进行数据验证
					if(response.body.status != 1){
						
						//提示错误信息
						this.$message({
								message: response.body.message,
								type: 'error',
								dangerouslyUseHTMLString:true,
								customClass: 'message-warning',
							});
						return;
					}
					
					//是否记住登录
					if(this.remember_username){
						localStorage.setItem('password',this.password);
						localStorage.setItem('phone',this.phone);
					}else{
						localStorage.removeItem('password');
						localStorage.removeItem('phone');
					}
					
					//保存用户信息
					sessionStorage.setItem('usercode',response.body.data.userCode);
					sessionStorage.setItem('portrait',response.body.data.portrait);
					sessionStorage.setItem('phone',this.phone);
					this.$router.push({
						name:`home`,
						params:{
							phone:this.phone,
							show:true
						}
					});	
					//跳转到首页
					$.ajax({
						type:'post',
						data:{usercode:sessionStorage.getItem('usercode')},
						url:_this.apiUrl+'index.php?m=Api&c=Content&a=openDemo',
						success: function(data){
								if(data.status==1){
									sessionStorage.setItem('socket_dot',true)
									Bus.$emit('first_dot',sessionStorage.getItem('socket_dot'))
								}else{
		//							console.log(data);
								}
							},
						error:function(){
	//						console.log(data);
						}
					})
					
					
					
					this.$message({
								message: '登录成功',
								type: 'success',
								dangerouslyUseHTMLString:true,
								customClass: 'message-warning',
							});
							
				Bus.$emit('sendLoginStates', {show:false,phone:this.phone});//robin
				},
					response => {
						
						
					});
				}
			}
			
		}
	}
</script>
<style>
	#login_phonem1,#login_pwdm1{
		font-size: 16px;
		text-indent: 16px;
	}
	#enterback {
		width: 100%;
		height: 100%;
		background: url(../assets/images/denglubg.png);
		background-size: 100% 100%;
	}
	#enterback .userdefault_enter{
		font-size: 16px;
		width: 100%;
	}
	#enter_checkbox{
		line-height: 16px;
		width: 16px; height: 16px; margin-left: 15px;
	}
	#enter_checkbox input{
		width: 16px;
		height: 16px;
		margin: 0;
	}
	#enter_forget{
		color: #6493F4;cursor: pointer;display: block;float: right;margin-right: 15px;
	}
	.enter_headline{
		height: 48px;
		text-align: center;
		padding-top: 20px;
	}
	.enter_btn{
		width: 300px;
		height: 45px;
		border-radius: 5px;
		color: white;
		background-color: #076CF2;
		border: 1px solid #076CF2;
		line-height: 45px;
		cursor: pointer;
		margin: 0 auto;
		margin-top: 15px;
		font-size: 18px;
		border: 0;
	}
</style>
<style scoped="scoped">
	.enter_right {
		width: 360px;
		height: 400px;
		background-color: white;
		border: 1px solid #D9D9DB;
		border-radius: 10px;
		box-shadow: #DADADC 0px 0px 30px 5px;
		margin: 0 auto;
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
	}
	
	.enter_wrap_main {
		width: 330px;
		height: 221px;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		margin: auto;		
	}
	.enter_wrap_main .phonenum {
		width: 330px;
		height: 88px;
		font-size: 14px;
	}
	.enter_wrap_main .phonenum>input {
		width: 300px;
		height: 43px;
		margin-top: 32px;
		border-radius: 5px;
		border: 1px solid #D9D9DB;
		text-indent: 1em;
	}
	.enter_wrap_main .phonenum span {
		width: 330px;
		height: 20px;
		font-size: 14px;
		line-height: 20px;
		color: red;
	}
	.enter_wrap_main .enterpass {
		width: 330px;
		height: 88px;
		font-size: 14px;
	}
	.enter_wrap_main .enterpass>input {
		width: 300px;
		height: 43px;
		/*margin-top: 32px;*/
		border-radius: 5px;
		border: 1px solid #D9D9DB;
		text-indent: 1em;
	}
	.enter_wrap_main .enterpass span {
		width: 330px;
		height: 20px;
		font-size: 14px;
		line-height: 20px;
		color: red;
	}
	.enter_wrap_main .userdefault_enter {
		width: 300px;
		height: 20px;
		margin: 0 auto;
		line-height: 20px;
		margin-bottom: 7px;
	}
	
	</style>


// WEBPACK FOOTER //
// src/views/enterPage.vue